import { useContext } from "react";

import { AuthContext } from "../store/AuthContext";
import type { AuthContextType } from "../store/AuthContext";

export type { AccountDetails, AuthUser, AuthContextType } from "../store/AuthContext";

export function useAuthUser(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error("useAuthUser must be used within AuthContextProvider");
  }
  return context;
}
